import dataStore from '../../../data/data';
import Mediaprocessing from '../../mediaprocessing/mediaprocessing';

let loading = false;
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const Loader = async () => {
  if (loading) return;

  const data = dataStore.getState();
  const delay = 1000; // 1 second
  const maxAttempts = 10;
  const sessionId = data.mirror.sessionId;
  
  if (!sessionId) return;

  let session;

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_PHI_WEB_URL}/mirror-cast-session-get?sessionId=${sessionId}`
      );

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      session = await res.json();

      if (session?.participants?.length) {
        break;
      }

      console.log(`Loader: no participants (attempt ${attempt}), trying again.`);
    } catch (err) {
      console.log(`Loader: attempt ${attempt} failed`, err);
    } finally {
      loading=false;
    }

    if (attempt < maxAttempts) {
      await wait(delay);
    }
  }

  if (!session?.participants?.length) {
    console.log('No participants returned in session loader: ', session);
    return;
  }

  const participants = session.participants || [];
  const vitruvian = data.mirror.vitruvianId;
  const vitruvianParticipant = participants.find(p => p.vitruvianId === vitruvian);
  const peers = participants.filter(p => p.vitruvianId !== vitruvian);

  await new Mediaprocessing().run({
      id: vitruvian,
      role: 'vitruvian',
      timestamp: vitruvianParticipant.timestamp
  });

  for (const peer of peers) {
    await new Mediaprocessing().run({
        id: peer.vitruvianId,
        role: 'peer',
        timestamp: peer.timestamp
    });
  }
};

export default Loader;